import { useCallback, useMemo } from 'react';
import { useSelector } from 'store';
import hasPermission from 'utils/hasPermission';

export default function usePermissions(operation) {
  const current = useSelector((state) => state.menu.currentItem);
  const permissions = useSelector((state) => state.auth.role?.permissions);

  const permitted = useMemo(() => hasPermission(current, permissions, operation), [current, permissions, operation]);
  const isPermitted = useCallback((operation) => hasPermission(current, permissions, operation), [current, permissions]);

  return { current, permitted, isPermitted };
}
